import React, { useRef } from "react";
// import logo from "../media/images/ft-logo-1.png";
import logo from "../media/images/logo.png";
import { Link } from "react-router-dom";

const Nav = () => {
  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle("landing-nav-open");
  };

  return (
    <div>
      <div className="landing-nav" >
        <div className="landing-nav-main">
          <Link to="/" className="landing-nav-logo">
            <img src={logo} alt="Fluffy Touch Logo" title="Premium At-Home Pet Grooming Services" />
          </Link>

          <div className="landing-nav-menu" ref={navRef}>
            <div
              className="landing-nav-btn landing-nav-close-btn"
              onClick={showNavbar}
            >
              <i className="fa-solid fa-circle-xmark"></i>
            </div>


           
           <Link title="Best Pet Grooming Near Me" to="/">Home</Link>
                       
                       <div className="navbar-drop">
                           <span>Price <i className="fa-solid fa-caret-down"></i></span>
                           <div className="navbar-drop-option">
                             <Link title="pet grooming" to="/pet-grooming">Pet Grooming</Link>
                             {/* <Link title="pet boarding" to="/pet-boarding">Pet Boarding</Link> */}
                             <Link title="pet hair cutting" to="/pet-hair-cutting">Pet Designer Haircut</Link>
                           </div>
                         </div>
           
                         <div className="navbar-drop">
                           <span>Grooming <i className="fa-solid fa-caret-down"></i></span>
                           <div className="navbar-drop-option">
                             <Link title="dog grooming page" to="/dog-grooming">Dog Grooming</Link>
                             <Link title="cat grooming page" to="/cat-grooming">Cat Grooming</Link>
                           </div>
                         </div>
           
                         {/* <div className="navbar-drop">
                           <span>Boarding <i className="fa-solid fa-caret-down"></i></span>
                           <div className="navbar-drop-option">
                             <Link title="dog boarding page" to="/dog-boarding">Dog Boarding</Link>
                             <Link title="cat boarding page" to="/cat-boarding">Cat Boarding</Link>
                           </div>
                         </div> */}
                         
                         
                         {/* <Link title="Pet Grooming Near Me" to="/price">Prices</Link> */}
                         {/* <Link title="Small Animal Grooming Near Me" to="/pet-grooming">Grooming</Link> */}
                         {/* <Link title="Pet Grooming" to="/pet-boarding">Boarding</Link> */}
                         <div className="navbar-drop">
                           <span>Company <i className="fa-solid fa-caret-down"></i></span>
                           <div className="navbar-drop-option">
                         <Link title="Home Pet Grooming Near Me" to="/about">About us</Link>
                         <Link title="Groomers Near Me" to="/gallery">Gallery</Link>
                           </div>
                         </div>
                         
                         <Link title=" Mobile Dog Grooming Near Me" to="/blog">Blog</Link>
                         <Link title="Dog Grooming Near Me" to="/contact">Contact us</Link>
                         <Link className="navbar-bottom-menu-button" title="Dog Grooming Near Me" target="_blank" to="tel:+919658189189">Book On Call</Link>
           
           
          </div>

          <div
            className="landing-nav-btn landing-nav-menu-btn"
            >
                    <Link title="Pet Grooming At Home" target="_blank" to="tel:+919658189189"> <i class="fa-solid fa-phone"></i>+919658-189-189</Link>
              
            
            <i onClick={showNavbar} className="fa-solid fa-bars"></i>
          </div>
        </div>
      </div>

      {/* <div className="navbar-main"></div>
      <div className="navbar">
        <div className="nav-logo">
          <Link title="Waxing Near Me" to="/">
            <img src={logo} alt="logo" title="Men's salon at home" />
          </Link>
        </div>

        <div className="nav-menu" ref={navRef}>
          <a href="#grooming">Grooming</a>
          <a href="#haircut">Haircut</a>
          <a href="#how-we-work">How we work</a>
          <a href="#why-us">Why us</a>
          <a href="#testimonials">Testimonials</a>
        </div>
        <button className="nav-btn menu-btn" onClick={showNavbar}>
          <i className="fa-solid fa-bars"></i>
        </button>
      </div> */}
    </div>
  );
};

export default Nav;
